import { useEffect } from 'react'

const TermsofUseOneTrust = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js'
    script.type = 'text/javascript'
    script.charset = 'UTF-8'
    script.id = 'otprivacy-notice-script'
    script.setAttribute(
      'settings',
      'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyIsImNvbnRlbnRBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L2NvbnRlbnQiLCJtZXRhZGF0YUFwaVVybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0='
    )

    document.body.appendChild(script)

    script.onload = () => {
      if (window.OneTrust?.NoticeApi?.Initialized) {
        window.OneTrust.NoticeApi.Initialized.then(() => {
          window.OneTrust.NoticeApi.LoadNotices([
            'https://privacyportal-cdn.onetrust.com/storage-container/245e6dbf-4480-4d87-a1c2-ab41d35145c1/privacy-notices/85371f3d-47ed-40ca-bb21-ace67e7a2425/published/privacynotice.json',
          ])
        })
      }
    }
  }, [])

  return (
    <div
      id="otnotice-85371f3d-47ed-40ca-bb21-ace67e7a2425"
      className="otnotice"
    ></div>
  )
}

export default TermsofUseOneTrust
